var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "19",
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10 4.03369V0.0336914H0V18.0337H20V4.03369H10ZM4 16.0337H2V14.0337H4V16.0337ZM4 12.0337H2V10.0337H4V12.0337ZM4 8.03369H2V6.03369H4V8.03369ZM4 4.03369H2V2.03369H4V4.03369ZM8 16.0337H6V14.0337H8V16.0337ZM8 12.0337H6V10.0337H8V12.0337ZM8 8.03369H6V6.03369H8V8.03369ZM8 4.03369H6V2.03369H8V4.03369ZM18 16.0337H10V14.0337H12V12.0337H10V10.0337H12V8.03369H10V6.03369H18V16.0337ZM16 8.03369H14V10.0337H16V8.03369ZM16 12.0337H14V14.0337H16V12.0337Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }